import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gerencia',
  templateUrl: './gerencia.component.html',
  styleUrls: ['./gerencia.component.css']
})
export class GerenciaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
